import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV || "development",
    debug: process.env.NODE_ENV === "development",

    release: "__PACKAGE_NAME__@__PACKAGE_VERSION__", // Set the release version for better error tracking

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    integrations: [
      // send console.log, console.warn, and console.error calls as logs to Sentry
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
      // Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      // Sentry.feedbackIntegration({
      //   // Additional SDK configuration goes in here, for example:
      //   colorScheme: "system",
      //   showName: false,
      // }),
    ],

    // Enable logs to be sent to Sentry
    enableLogs: true,

    // tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/bestory\.adobedemo\.com/,
      /^https:\/\/bestory\.adobed\.com/,
    ],
  });
}
